/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CallStartedWebhookPayload } from '../../models/call-started-webhook-payload';

export interface PostCallStartedWebhookSchema$Params {
}

export function postCallStartedWebhookSchema(http: HttpClient, rootUrl: string, params?: PostCallStartedWebhookSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CallStartedWebhookPayload>> {
  const rb = new RequestBuilder(rootUrl, postCallStartedWebhookSchema.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CallStartedWebhookPayload>;
    })
  );
}

postCallStartedWebhookSchema.PATH = '/api/webhooks/notifications/events/CallStarted';
